import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const GeriatricsAndGerontologyIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M79.7856 40C79.7856 61.8153 62.1009 79.5 40.2856 79.5C18.4704 79.5 0.785645 61.8153 0.785645 40C0.785645 18.1848 18.4704 0.5 40.2856 0.5C62.1009 0.5 79.7856 18.1848 79.7856 40Z'
      />
      <path
        d='M50.3741 48.0023L53.1554 45.2211L43.3991 41.5625H37.1491L27.3921 45.2211L30.1726 48.0023C31.6483 49.4781 32.4608 51.4391 32.4608 53.5258V55.625H48.0858V53.5258C48.0858 51.4398 48.8983 49.4781 50.3741 48.0023Z'
        fill='#FAB400'
      />
      <path
        d='M29.8022 45.4898L40.2741 41.5625H37.1491L27.3921 45.2211L28.5437 46.3727C28.878 45.9875 29.303 45.6766 29.8022 45.4898Z'
        fill='#DC9600'
      />
      <path
        d='M43.3989 41.5625V36.875H37.1489V41.5625L40.2739 44.6875L43.3989 41.5625Z'
        fill='#D2AA82'
      />
      <path
        d='M48.0864 27.5H46.5239V24.2289C46.5239 22.4836 45.095 21.0773 43.3505 21.1039L37.1005 21.2015C35.3935 21.2281 34.0239 22.6195 34.0239 24.3265V27.5H32.4614C31.5981 27.5 30.8989 28.1992 30.8989 29.0625V29.6594C30.8989 30.2515 31.2333 30.7922 31.763 31.057L34.0239 32.1875V34.0179C34.0239 34.8469 34.3528 35.6414 34.9395 36.2273L36.2341 37.5219C36.82 38.1078 37.6153 38.4375 38.4435 38.4375H42.1044C42.9333 38.4375 43.7278 38.1086 44.3138 37.5219L45.6083 36.2273C46.1942 35.6414 46.5239 34.8461 46.5239 34.0179V32.1875L48.7849 31.057C49.3146 30.7922 49.6489 30.2515 49.6489 29.6594V29.0625C49.6489 28.1992 48.9497 27.5 48.0864 27.5Z'
        fill='#F0C8A0'
      />
      <path
        d='M40.2741 35.0562C39.7522 35.0562 39.2616 34.853 38.8929 34.4843L38.4351 34.0265C38.2827 33.8741 38.2827 33.6265 38.4351 33.4741C38.5874 33.3218 38.8351 33.3218 38.9874 33.4741L39.4452 33.9319C39.8874 34.3741 40.6601 34.3741 41.103 33.9319L41.5601 33.4741C41.7124 33.3218 41.9601 33.3218 42.1124 33.4741C42.2647 33.6265 42.2647 33.8741 42.1124 34.0265L41.6554 34.4843C41.2866 34.853 40.796 35.0562 40.2741 35.0562Z'
        fill='#BE7800'
      />
      <path
        d='M37.9302 30.625C38.3616 30.625 38.7114 30.2752 38.7114 29.8438C38.7114 29.4123 38.3616 29.0625 37.9302 29.0625C37.4987 29.0625 37.1489 29.4123 37.1489 29.8438C37.1489 30.2752 37.4987 30.625 37.9302 30.625Z'
        fill='#BE7800'
      />
      <path
        d='M42.6177 30.625C43.0491 30.625 43.3989 30.2752 43.3989 29.8438C43.3989 29.4123 43.0491 29.0625 42.6177 29.0625C42.1862 29.0625 41.8364 29.4123 41.8364 29.8438C41.8364 30.2752 42.1862 30.625 42.6177 30.625Z'
        fill='#BE7800'
      />
      <path
        d='M48.0864 29.0625C46.3606 29.0625 44.9614 27.6633 44.9614 25.9375V21.25H46.5239C47.3872 21.25 48.0864 21.9492 48.0864 22.8125V29.0625Z'
        fill='#D2D2D2'
      />
      <path
        d='M32.4614 25.9375V24.375C32.4614 20.9234 35.2599 18.125 38.7114 18.125H43.3989C45.1247 18.125 46.5239 19.5242 46.5239 21.25C46.5239 22.2336 46.0606 23.1602 45.2739 23.75L42.7739 25.625C41.1513 26.8422 39.1771 27.5 37.1489 27.5H34.0239C33.1614 27.5 32.4614 26.8008 32.4614 25.9375Z'
        fill='#F0F0F0'
      />
      <path d='M23.0859 57.1875H32.4609V61.875H23.0859V57.1875Z' fill='#3CC8B4' />
      <path d='M23.0859 57.1875H26.2109V61.875H23.0859V57.1875Z' fill='#1EAA96' />
      <path d='M48.0859 57.1875H57.4609V61.875H48.0859V57.1875Z' fill='#3CC8B4' />
      <path d='M48.0859 57.1875H51.2109V61.875H48.0859V57.1875Z' fill='#1EAA96' />
      <path
        d='M62.1437 36.875H61.9102C61.1461 36.875 60.4945 37.4273 60.3687 38.1805L59.3531 44.2742C59.1391 45.5594 58.5289 46.7453 57.6078 47.6656L55.8984 49.375L57.1312 46.9094C57.3484 46.4758 57.4609 45.9969 57.4609 45.5117V45.0102C57.4609 44.3141 56.6195 43.9656 56.1273 44.4578L51.4789 49.1062C50.307 50.2781 49.6484 51.868 49.6484 53.5258V57.1875H55.8984V55.6805C55.8984 54.6445 56.3102 53.6508 57.0422 52.9187L60.3164 49.6445C61.4891 48.4719 62.1477 46.8859 62.1469 45.2281C62.1461 41.9938 62.1437 36.875 62.1437 36.875Z'
        fill='#F0C8A0'
      />
      <path
        d='M18.4038 36.875H18.6374C19.4015 36.875 20.053 37.4273 20.1788 38.1805L21.1944 44.2742C21.4085 45.5594 22.0187 46.7453 22.9397 47.6656L24.6483 49.375L23.4155 46.9094C23.1983 46.4758 23.0858 45.9969 23.0858 45.5117V45.0102C23.0858 44.3141 23.9272 43.9656 24.4194 44.4578L29.0679 49.1062C30.2397 50.2781 30.8983 51.868 30.8983 53.5258V57.1875H24.6483V55.6805C24.6483 54.6445 24.2366 53.6508 23.5046 52.9187L20.2304 49.6445C19.0577 48.4719 18.3991 46.8859 18.3999 45.2281C18.4007 41.9938 18.403 36.8758 18.4038 36.875Z'
        fill='#F0C8A0'
      />
      <path
        d='M55.9052 19.6875L56.552 19.0406C57.138 18.4539 57.9333 18.125 58.7622 18.125H59.0302C61.6052 18.125 63.0755 21.0648 61.5302 23.125L55.9052 30.625L50.2802 23.125C48.7349 21.0648 50.2052 18.125 52.7802 18.125H53.0481C53.877 18.125 54.6716 18.4539 55.2575 19.0406L55.9052 19.6875Z'
        fill='#FA6450'
      />
      <path
        d='M51.8364 23.125C50.4255 21.2437 51.5325 18.6359 53.695 18.1961C53.4841 18.1516 53.2677 18.125 53.0481 18.125H52.7802C50.2052 18.125 48.7349 21.0648 50.2802 23.125L55.9052 30.625L56.6833 29.5875L51.8364 23.125Z'
        fill='#DC4632'
      />
      <path
        d='M39.5044 43.9055V55.625H41.0669V43.9071L40.2864 44.6875L39.5044 43.9055Z'
        fill='#DC9600'
      />
      <path d='M37.1616 41.5625V46.25L40.2866 44.6875L37.1616 41.5625Z' fill='#BE7800' />
      <path d='M43.4116 41.5625V46.25L40.2866 44.6875L43.4116 41.5625Z' fill='#BE7800' />
      <path
        d='M40.2856 49.375C39.8544 49.375 39.5044 49.025 39.5044 48.5938C39.5044 48.1625 39.8544 47.8125 40.2856 47.8125C40.7169 47.8125 41.0669 48.1625 41.0669 48.5938C41.0669 49.025 40.7169 49.375 40.2856 49.375Z'
        fill='#BE7800'
      />
      <path
        d='M40.2856 54.0625C39.8544 54.0625 39.5044 53.7125 39.5044 53.2812C39.5044 52.85 39.8544 52.5 40.2856 52.5C40.7169 52.5 41.0669 52.85 41.0669 53.2812C41.0669 53.7125 40.7169 54.0625 40.2856 54.0625Z'
        fill='#BE7800'
      />
      <path
        d='M38.7114 29.4531H35.5864C35.3708 29.4531 35.1958 29.2781 35.1958 29.0625C35.1958 28.8469 35.3708 28.6719 35.5864 28.6719H38.7114C38.9271 28.6719 39.1021 28.8469 39.1021 29.0625C39.1021 29.2781 38.9278 29.4531 38.7114 29.4531Z'
        fill='#F0F0F0'
      />
      <path
        d='M44.9614 29.4531H41.8364C41.6208 29.4531 41.4458 29.2781 41.4458 29.0625C41.4458 28.8469 41.6208 28.6719 41.8364 28.6719H44.9614C45.1771 28.6719 45.3521 28.8469 45.3521 29.0625C45.3521 29.2781 45.1778 29.4531 44.9614 29.4531Z'
        fill='#F0F0F0'
      />
    </svg>
  )
);
GeriatricsAndGerontologyIcon.displayName = 'GeriatricsAndGerontologyIcon';

export default GeriatricsAndGerontologyIcon;
